import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {LocalStorageService} from '../../../../services/local-storage.service';
import {MatStepper} from '@angular/material/stepper';
import {CommonService} from '../../../../services/common.service';
import {ToastMessagesService} from '../../../../services/toast-messages.service';

@Component({
  selector: 'app-auth-step',
  templateUrl: './auth-step.component.html',
  styleUrls: ['./auth-step.component.scss']
})
export class AuthStepComponent implements OnInit {
  isLinear = true;
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  userId: number;
  user: any;
  providers: any;
  steps: number;
  step1Title = 'Βήμα 1';
  step2Title: string;
  step3Title = 'Ολοκλήρωση';
  maskedPhone: any;
  maskedEmail: any;
  submitPressed: any;
  radioSelection: any;
  consentQuestions = [];
  authStepMessage = ' ';
  @ViewChild('stepper', {static: false}) stepper: MatStepper;
  firstStepLoading: boolean;
  secondStepLoading: boolean;
  secretCode = '';
  childId: number;
  formId: number;
  securityResponse: boolean;
  mode: string;


  constructor(private formBuilder: FormBuilder,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private localStorageService: LocalStorageService,
              private commonService: CommonService,
              public toastMessagesService: ToastMessagesService,
              public dialogRef: MatDialogRef<AuthStepComponent>) {
    this.mode = data.mode;
    this.securityResponse = false;
    this.userId = +data.userId;
    this.user = JSON.parse(this.localStorageService.get('user'));
    this.submitPressed = data.submitPressed;
    this.consentQuestions = data.consents;
    this.childId = +data.childId;
    this.formId = +data.formId;
    this.providers = this.user.providers;
    this.steps = this.providers ? 2 : 3;

    this.step2Title = this.steps === 2 ? 'Βήμα 1' : 'Βήμα 2';

    this.maskedPhone = `*******`;
    const last3PhoneDigits = this.user.telephone.substr(this.user.telephone.length - 3);
    this.maskedPhone += last3PhoneDigits;
    this.maskedEmail = this.maskEmail(this.user.email);
    console.log('user notification provider');
    console.log(this.user.providers);
    if (this.steps === 2) {
      this.authStepMessage = +this.user.providers === 1 ?
        `Πληκτρολογήστε τον κωδικό που σας έχει αποσταλεί στο email ${this.maskedEmail}` :
        `Πληκτρολογήστε τον κωδικό που σας έχει αποσταλεί στο κινητό ${this.maskedPhone}`;
    }
  }

  async ngOnInit() {
    this.firstFormGroup = this.formBuilder.group({
      firstCtrl: ['', Validators.required]
    });
    this.secondFormGroup = this.formBuilder.group({
      secondCtrl: ['', Validators.required]
    });

    if (this.steps === 2) {
      try {
        // tslint:disable-next-line:max-line-length
        const response: any = await this.commonService.updateItem(`twoStep/consents?parentId=${this.user.id}`, {childId: this.childId, formId: this.formId, consentQuestions: this.consentQuestions});
        this.toastMessagesService.toastMessages(response.object.message);
      } catch (e) {
        this.toastMessagesService.toastErrorMessage(e.message);
      }
    }
  }

  async next() {
    if (this.steps === 3) {
      if (this.stepper.selectedIndex === 0) {
        try {
          this.firstStepLoading = true;
          const option = +this.radioSelection === 1 ? 'sms' : 'email';

          await this.commonService.updateItem(`people/parents/providers?parentId=${this.user.id}&provider=${option}`, {});

          const response: any = await this.commonService.
          updateItem(`twoStep/consents?parentId=${this.user.id}`,
              {childId: this.childId, formId: this.formId, consentQuestions: this.consentQuestions});

          this.toastMessagesService.toastMessages(response.object.message);
          this.authStepMessage = response.object.provider === 'email' ?
            `Πληκτρολογήστε τον κωδικό που έχει αποσταλεί στο email ${this.maskedEmail}` :
            `Πληκτρολογήστε τον κωδικό που έχει αποσταλεί στο κινητό ${this.maskedPhone}`;
          this.stepper.next();
          this.firstStepLoading = false;
        } catch (e) {
          this.toastMessagesService.toastErrorMessage(e.message);
        }

      } else if (this.stepper.selectedIndex === 1) {

        try {
          this.secondStepLoading = true;
          const response = await this.submitTwoFactorCode();

          if (response && response.status === 200) {
            this.securityResponse = true;
            this.stepper.next();
          } else {
            this.toastMessagesService.toastErrorMessage('Ο κωδικός που πληκτρολογήσατε δεν είναι σωστός');
          }
        } catch (e) {
          this.toastMessagesService.toastErrorMessage(`Ο κωδικός που πληκτρολογήσατε δεν είναι σωστός`);
        } finally {
          this.secondStepLoading = false;
        }
      }
    }

    if (this.steps === 2) {
      if (this.stepper.selectedIndex === 0) {
        try {
          this.secondStepLoading = true;
          const response = await this.submitTwoFactorCode();
          console.log(response);
          if (response && response.status === 200) {
            this.securityResponse = true;
            this.stepper.next();
          } else {
            this.toastMessagesService.toastErrorMessage('Ο κωδικός που πληκτρολογήσατε δεν είναι σωστός');
          }
        } catch (e) {
          console.log(e);
          this.toastMessagesService.toastErrorMessage(e.message);
        } finally {
          this.secondStepLoading = false;
        }
      }
    }
  }


  async submitTwoFactorCode() {
    try {
      const response: any = await this.commonService.insertItem(`twoStep/consents/authStep`, {
        userId: this.user.id,
        securityNumber: this.secretCode,
        consents: this.consentQuestions,
        childId: this.childId,
        formId: this.formId
      });
      return response;
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  previous() {
    this.stepper.previous();
  }


  closeDialog() {
    this.dialogRef.close(this.securityResponse);
  }

  maskEmail(email) {
    let maskId = '';
    const prefix = email.substring(0, email.lastIndexOf('@'));
    const postfix = email.substring(email.lastIndexOf('@'));

    for (let i = 0; i < prefix.length; i++) {
      if (i === 0 || i === prefix.length - 1) {
        maskId = maskId + prefix[i].toString();
      } else {
        maskId = maskId + '*';
      }
    }
    maskId = maskId + postfix;
    return maskId;
  }

  proceedStep() {
    return !this.radioSelection;
  }

  setValue(option: number) {
    this.radioSelection = option;
  }

  validCode() {
    return this.secretCode.length !== 6;
  }

}
